import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
  },
  content: {
    padding: theme.spacing(3),
  },
  actions: {
    padding: theme.spacing(2),
  },
}));

/**
 * Reusable confirmation dialog component
 * 
 * @param {boolean} open - Controls dialog visibility
 * @param {string} title - Dialog title (default: "Confirm Action")
 * @param {string} message - Confirmation message
 * @param {function} onConfirm - Callback when user clicks confirm
 * @param {function} onCancel - Callback when user clicks cancel or closes dialog
 * @param {string} confirmText - Text for confirm button (default: "Confirm")
 * @param {string} cancelText - Text for cancel button (default: "Cancel")
 * @param {string} confirmColor - Color of confirm button (default: "primary")
 */
export default function ConfirmDialog({
  open,
  title = "Confirm Action",
  message,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "primary",
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      maxWidth="sm"
      fullWidth
      disableEnforceFocus={true}
    >
      <DialogTitle id="confirm-dialog-title" className={classes.title}>
        {title}
      </DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText id="confirm-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button onClick={onCancel} color="default">
          {cancelText}
        </Button>
        <Button onClick={onConfirm} color={confirmColor} variant="contained" autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
